import { render, staticRenderFns } from "./OALogo.vue?vue&type=template&id=78a2b25c&scoped=true&"
import script from "./OALogo.vue?vue&type=script&lang=js&"
export * from "./OALogo.vue?vue&type=script&lang=js&"
import style0 from "./OALogo.vue?vue&type=style&index=0&id=78a2b25c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a2b25c",
  null
  
)

export default component.exports